
import { formatDate } from '../../utils/date-handlers';
import { Vue, Component, Inject, Prop, Watch } from 'vue-property-decorator'
import ImagesPreview from '../Generics/Images/ImagesPreview.vue'
import LoadingIndicator from '../Generics/LoadingIndicator.vue'
import { Note } from '../../../shared/types/notes/notes';
import { InjectionKey } from '../../injection-keys';
import { TenantConfig } from '../../../tenants/types';

@Component({
  components: {
    ImagesPreview,
    LoadingIndicator
  }
})
export default class NoteList extends Vue {
  @Prop({ default: false }) deletingNote!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ required: true }) notes!: Note[];
  @Prop({ type: Boolean, default: false }) showSamplingLabels!: boolean;
  /** Nota georreferenciada seleccionada (compartida con el mapa): se resalta y se hace scroll hasta ella. */
  @Prop({ default: null }) selectedNoteId!: number | null;

  @Watch('selectedNoteId')
  onSelectedNoteIdChange() {
    this.scrollToSelectedNote();
  }

  // Las notas pueden llegar después de la selección (pestaña recién abierta)
  @Watch('notes')
  onNotesChange() {
    this.scrollToSelectedNote();
  }

  isLocatable(note: Note): boolean {
    return note.id != null && !!note.location;
  }

  onNoteClick(note: Note) {
    if (!this.isLocatable(note)) return;
    this.$emit('select', note.id === this.selectedNoteId ? null : note.id);
  }

  onNoteHover(note: Note | null) {
    this.$emit('hover', note && this.isLocatable(note) ? note.id : null);
  }

  scrollToSelectedNote() {
    if (this.selectedNoteId == null) return;
    this.$nextTick(() => {
      const ref = this.$refs[`note-${this.selectedNoteId}`] as any;
      const item = Array.isArray(ref) ? ref[0] : ref;
      const el: HTMLElement | undefined = item && (item.$el || item);
      const container = this.$refs.notesScroll as HTMLElement | undefined;
      if (!el || !container) return;
      // Solo scrollea el contenedor de notas (scrollIntoView movería toda la página)
      const containerRect = container.getBoundingClientRect();
      const itemRect = el.getBoundingClientRect();
      if (itemRect.top < containerRect.top) {
        container.scrollBy({ top: itemRect.top - containerRect.top, behavior: 'smooth' });
      } else if (itemRect.bottom > containerRect.bottom) {
        container.scrollBy({ top: itemRect.bottom - containerRect.bottom, behavior: 'smooth' });
      }
    });
  }
  @Inject({ from: InjectionKey.Tenant, default: null }) readonly tenant!: TenantConfig | null;

  /** Autor de la nota (`user_name`) según `features.noteAuthor`. */
  get showAuthor(): boolean {
    return !!this.tenant && this.tenant.features.noteAuthor;
  }

  isSamplingNote(note: Note): boolean {
    return note.sampling != null;
  }

  /** Prefer hex color from enrichment; fall back to primary blue */
  muestraChipStyle(note: Note): Record<string, string> {
    const color = note.sampling_marker_color || '#1976D2';
    return { backgroundColor: color, borderColor: color };
  }

  displayNoteText(text: string | null | undefined): string {
    return text != null && String(text).trim() !== '' ? text : '-';
  }

  parseDate(date: string): string {
    return formatDate(date, false, false);
  }
}
